const API_BASE = '/api';

function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('sessionToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

export interface Holding {
  id: string;
  user_id: string;
  symbol: string;
  shares: number;
  purchase_price?: number;
  purchase_date?: number;
  notes?: string;
  currentPrice?: number;
  currency?: string; // Native currency of the stock (e.g., 'USD', 'GBP', 'EUR')
  totalValue?: number;
  totalValueUSD?: number; // Value converted to USD for aggregation
  costBasis?: number;
  gainLoss?: number;
  gainLossPercent?: number;
  created_at: number;
  updated_at: number;
}

export async function getPortfolio(): Promise<Holding[]> {
  const response = await fetch(`${API_BASE}/portfolio`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch portfolio');
  }

  return response.json();
}

export async function addHolding(
  symbol: string, 
  shares: number, 
  purchasePrice?: number, 
  purchaseDate?: number,
  notes?: string
): Promise<Holding> {
  const response = await fetch(`${API_BASE}/portfolio`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ 
      symbol, 
      shares, 
      purchase_price: purchasePrice,
      purchase_date: purchaseDate,
      notes 
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to add holding');
  }

  return response.json();
}

export async function updateHolding(id: string, shares: number): Promise<Holding> {
  const response = await fetch(`${API_BASE}/portfolio/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ shares }),
  });

  if (!response.ok) {
    throw new Error('Failed to update holding');
  }

  return response.json();
}

export async function deleteHolding(id: string): Promise<void> {
  const response = await fetch(`${API_BASE}/portfolio/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to delete holding');
  }
}
